module.exports = __webpack_public_path__ + "img/seltzer.bf7250df.png";